// extracted by mini-css-extract-plugin
module.exports = {"link":"styles__link___3g4Ac","linkContainer":"styles__linkContainer___pBjq8"};